export interface ISelectedExportValuesState {
    aanvraagSelectValue: string[];
    analistSelectValue: string[];
    biometrieSelectValue: string[];
    consultSelectValue: string[];
    declaratieSelectValue: string[];
    factuurOrgGrpSelectValue: string[];
    factuurPatientSelectValue: string[];
    gradingSelectValue: string[];
    instellingenSelectValue: string[];
    patientSelectValue: string[];
    procesSelectValue: string[];
    supervisieSelectValue: string[];
    uitbetalingSelectValue: string[];
}

export type SelectedExportValuesStatePayload = {
    [K in keyof ISelectedExportValuesState]: ISelectedExportValuesState[K];
};

export interface IAction {
    payload: SelectedExportValuesStatePayload;
    type: 'SET_SELECTED_VALUES';
}

export function selectedExportValuesReducer(
    state: SelectedExportValuesStatePayload,
    action: IAction
): ISelectedExportValuesState {
    const payloadWithEmptyArrays = Object.entries(action.payload).reduce((payload, [key, value]) => {
        payload[key as keyof typeof payload] = value || [];

        return payload;
    }, {} as SelectedExportValuesStatePayload);

    switch (action.type) {
        case 'SET_SELECTED_VALUES':
            return {
                ...state,
                ...payloadWithEmptyArrays,
            };
        default:
            return state;
    }
}
